import { render, staticRenderFns } from "./ObjectsTable.vue?vue&type=template&id=1f630700&"
import script from "./ObjectsTable.vue?vue&type=script&lang=js&"
export * from "./ObjectsTable.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsTable.vue?vue&type=style&index=0&id=1f630700&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports